// extracted by mini-css-extract-plugin
export default {"icon":"type_tooltip_icon-module___icon___b3965755"};